/* ══════════════════════════════════════════════════════════════
   Commodity Panel — Gold, Silver, Crude MCX Prices
   ══════════════════════════════════════════════════════════════ */

import { fetchCommodities } from '../services/market-data';
import { renderUnavailableBlock } from './data-state';

export interface CommodityData {
  name: string;
  emoji: string;
  price: number;
  unit: string;
  change: number;
  changePct: number;
  mcxPrice?: number;
  mcxUnit?: string;
}

const COMMODITY_EMOJI: Record<string, string> = {
  'gold': '🥇', 'silver': '🥈', 'crude oil': '🛢️', 'crude': '🛢️',
  'natural gas': '🔥', 'copper': '🟤', 'aluminium': '⬜', 'zinc': '🔵',
  'lead': '⚫', 'nickel': '🟤', 'cotton': '🧶',
};

function renderWithData(container: HTMLElement, data: CommodityData[]): void {
  const cards = data.map(c => {
    const isUp = c.change >= 0;
    const color = isUp ? 'var(--india-green)' : 'var(--india-red)';
    return `
      <div class="commodity-card glass-card">
        <div class="comm-header">
          <span class="comm-emoji">${c.emoji}</span>
          <span class="comm-name">${c.name}</span>
        </div>
        <div class="comm-prices">
          <div class="comm-global">
            <span class="comm-price">${c.price.toLocaleString('en-US')}</span>
            <span class="comm-unit">${c.unit}</span>
          </div>
          ${c.mcxPrice ? `<div class="comm-mcx"><span class="comm-price">₹${c.mcxPrice.toLocaleString('en-IN')}</span><span class="comm-unit">${c.mcxUnit}</span></div>` : ''}
        </div>
        <span class="comm-change" style="color:${color}">${isUp ? '▲' : '▼'} ${Math.abs(c.change)} (${c.changePct >= 0 ? '+' : ''}${c.changePct.toFixed(1)}%)</span>
      </div>`;
  }).join('');

  container.innerHTML = `
    <div class="commodity-panel"><div class="card-header"><h3>📦 Commodities</h3></div><div class="commodity-grid">${cards}</div></div>`;
}

export function renderCommodityPanel(container: HTMLElement, commodities?: CommodityData[]): void {
  if (commodities) {
    renderWithData(container, commodities);
  } else {
    container.innerHTML = renderUnavailableBlock('commodity-panel', 'Loading commodities...');
    fetchCommodities().then(apiData => {
      if (apiData && apiData.length > 0) {
        const mapped: CommodityData[] = apiData.map(c => ({
          name: c.name || c.symbol || '',
          emoji: COMMODITY_EMOJI[c.name?.toLowerCase()] || COMMODITY_EMOJI[c.symbol?.toLowerCase()] || '📦',
          price: c.price || 0,
          unit: c.unit || '',
          change: c.change || 0,
          changePct: c.pChange || 0,
        }));
        renderWithData(container, mapped);
      } else {
        container.innerHTML = renderUnavailableBlock('commodity-panel', 'Live commodity feed unavailable');
      }
    }).catch(() => {
      container.innerHTML = renderUnavailableBlock('commodity-panel', 'Live commodity feed unavailable');
    });
  }
}
